/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   City guide city bizos
 */

import camelcaseKeys from 'camelcase-keys'
import type { CityGuideCity as CityGuideCityType, RawCityGuideCity } from './cityGuideCity.types'

export const CityGuideCity = {
  fromJS: (data: RawCityGuideCity): CityGuideCityType => camelcaseKeys(data),
}

export type CityGuideCity = CityGuideCityType
